import moment from 'moment';
import {Filter} from './types/filter';

export function isEmpty(val: any, allowEmptyArrayOrObject?: boolean): boolean {
    if (val == null) {
        return true;
    }

    if (Array.isArray(val)) {
        return val.length < 1 && !allowEmptyArrayOrObject;
    }

    // let`s check for object
    if (val.constructor === Object) {
        return Object.keys(val).length < 1 && !allowEmptyArrayOrObject;

    }

    return String(val).trim() === '';
}

export function filterGetQueryString(filters: Filter[]) {
    // update filters
    let filtersString = '';

    for (let filter of filters) {
        if (filter.value == null) {
            continue;
        }

        let value: any = null;

        if (filter.value instanceof Date) {
            value = moment(filter.value).format('YYYY-MM-DD');
        } else {
            value = filter.value;
        }

        if (filtersString != '') {
            filtersString += ';';
        }

        filtersString += filter.name + '=' + value;

    }
    return filtersString;
}

export function filterClear(filters: Filter[]) {
    // update filters
    let filtersString = '';

    for (let filter of filters) {
        filter.value = null;
    }

    return filtersString;
}

export  function  byAcceptedExtensionsFilter($f: File, fileExtensions: string): boolean {
    return !!$f && (
        !fileExtensions
        || !fileExtensions.length
        || !!fileExtensions.split(',').find($ext => $f.name && $f.name.toLowerCase().endsWith($ext.charAt(0) === '.' ? $ext : `.${$ext}`))
    );
}
